/** Class EnableGoogleMaps
 * Author Julien Winant
 * Author Email : julien@charlin.be
 * Author website : https://harkor.be
 * Author website : https://www.charlin.be
 */

const google = window.google;

class EnableGoogleMaps {
  constructor() {
    this.allmarkers = [];
    this.map;
    this.currentMarker;
    this.$sliderRangeDateMap;
    this.initialDate = new Date('2015-06-01T00:00:00');
    this.$startMonthInput = null;
    this.$startYearInput = null;
    this.$endMonthInput = null;
    this.$endYearInput = null;
    this.allReferents = [];
    this.nearbyMakers = [];
    this.makersById = {};
    // this.nonce = automaticMapSettings.nonce;
    this.Months = [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ];

    this.markerTypes = [
      'maker',
      'maker-valide',
      'appareils-a-matcher',
      'appareils-en-cours',
      'appareils-livres',
    ];

    this.init();
  }

  init() {
    var self = this;

    this.createMap();
    this.handleDatePicker();
    this.loadMarkers();
    this.handleModal();

    // Globals Events Listener
    $(':checkbox').on('click', function () {
      self.searchMarkers(false);
    });

    $('.sidebar-map .return-icon').on('click', function (event) {
      event.preventDefault();
      var _this = $(this);
      var target = _this.data('target');
      $(target).removeClass('open');
    });

    $('.google-map-auto .open-main-sidebar').on('click', function (event) {
      event.preventDefault();

      var _this = $(this);
      var target = _this.data('target');
      if ($(window).width() <= 620) {
        $(target).addClass('open');
      }
    });

    $('#google-map-search').on('submit', function (event) {
      event.preventDefault();
      self.searchMarkers();
    });

    $('.btn[data-action=toggle-sidebar]').on('click', function (event) {
      event.preventDefault();
      $('.sidebar-map.marker-groups').toggleClass('open');
    });
  }

  createMap() {
    var mapOptions = {
      zoom: 6,
      center: new google.maps.LatLng(46.99438106504065, 2.584971105743521),
      mapTypeControl: false,
    };

    this.map = new google.maps.Map(
      $('.google-map-auto .enable-map')[0],
      mapOptions
    );

    $('.google-map-auto .loading-markers').addClass('showw');
  }

  handleDatePicker() {
    const self = this;

    // Initialisation du sélecteur de date existant
    $('.enable-map-datepicker').datepicker({
      language: 'fr-FR',
      format: 'dd/mm/yyyy',
    });

    $('.enable-map-datepicker').on('change', function () {
      self.searchMarkers();
    });

    self.$sliderRangeDateMap = $('#slider-range-date-map');

    // Initialisation des sliders
    self.$sliderRangeDateMap.slider({
      range: true,
      min: 0,
      max: parseInt(self.$sliderRangeDateMap.data('max-months')) + 1,
      values: [0, parseInt(self.$sliderRangeDateMap.data('max-months'))],
      slide: function (event, ui) {
        self.dateRangeChange(ui.values);
      },
      create: function () {
        self.dateRangeChange();
      },
    });

    // Gestion des champs de saisie manuelle pour le début / fin
    this.$startMonthInput = $('#start-month-input');
    this.$startYearInput = $('#start-year-input');
    this.$endMonthInput = $('#end-month-input');
    this.$endYearInput = $('#end-year-input');

    const manualInputs = [
      this.$startMonthInput,
      this.$startYearInput,
      this.$endMonthInput,
      this.$endYearInput,
    ];

    manualInputs.forEach(function ($input) {
      if ($input && $input.length) {
        $input.on('change', function () {
          self.updateSliderFromInputs(
            self.$startMonthInput.val(),
            self.$startYearInput.val(),
            self.$endMonthInput.val(),
            self.$endYearInput.val()
          );
        });
      }
    });
  }

  dateRangeChange(values) {
    var self = this;

    if (values == undefined) {
      values = self.$sliderRangeDateMap.slider('values');
    }

    var initialDate = this.initialDate;

    var fromDate = new Date(initialDate);
    var endDate = new Date(initialDate);

    fromDate.setMonth(initialDate.getMonth() + values[0]); // First day of the month

    endDate.setMonth(initialDate.getMonth() + values[1]);
    endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0); // Last day of the month

    $('.slider-range-data-map-wrapper .date-start').text(
      this.Months[fromDate.getMonth()] + ' ' + fromDate.getFullYear()
    );
    $('.slider-range-data-map-wrapper .date-end').text(
      this.Months[endDate.getMonth()] + ' ' + endDate.getFullYear()
    );

    $('.slider-range-data-map-wrapper #date_from').val(
      fromDate.getTime() / 1000
    );
    $('.slider-range-data-map-wrapper #date_to').val(endDate.getTime() / 1000);

    if (this.$startMonthInput && this.$startMonthInput.length) {
      this.$startMonthInput.val(fromDate.getMonth() + 1);
    }

    if (this.$startYearInput && this.$startYearInput.length) {
      this.$startYearInput.val(fromDate.getFullYear());
    }

    if (this.$endMonthInput && this.$endMonthInput.length) {
      this.$endMonthInput.val(endDate.getMonth() + 1);
    }

    if (this.$endYearInput && this.$endYearInput.length) {
      this.$endYearInput.val(endDate.getFullYear());
    }

    self.searchMarkers();
  }

  updateSliderFromInputs(startMonth, startYear, endMonth, endYear) {
    if (!this.$sliderRangeDateMap || !this.$sliderRangeDateMap.length) {
      return;
    }

    const startIndex = this.getMonthIndex(startMonth, startYear);

    if (startIndex === null) {
      return;
    }

    let endIndex = this.getMonthIndex(endMonth, endYear);

    if (endIndex === null) {
      const currentSliderValues = this.$sliderRangeDateMap.slider('values');
      endIndex = currentSliderValues ? currentSliderValues[1] : startIndex;
    }

    const sliderMin = this.$sliderRangeDateMap.slider('option', 'min') || 0;
    const sliderMax = this.$sliderRangeDateMap.slider('option', 'max');

    const clampValue = function (value) {
      let clampedValue = value;

      if (typeof sliderMin === 'number') {
        clampedValue = Math.max(sliderMin, clampedValue);
      }

      if (typeof sliderMax === 'number') {
        clampedValue = Math.min(sliderMax, clampedValue);
      }

      return clampedValue;
    };

    let adjustedStart = clampValue(startIndex);
    let adjustedEnd = clampValue(endIndex);

    if (adjustedEnd < adjustedStart) {
      adjustedEnd = adjustedStart;
    }

    this.$sliderRangeDateMap.slider('values', [adjustedStart, adjustedEnd]);
    this.dateRangeChange([adjustedStart, adjustedEnd]);
  }

  getMonthIndex(month, year) {
    const monthInt = parseInt(month, 10);
    const yearInt = parseInt(year, 10);

    if (isNaN(monthInt) || isNaN(yearInt)) {
      return null;
    }

    if (monthInt < 1 || monthInt > 12) {
      return null;
    }

    const initialYear = this.initialDate.getFullYear();
    const initialMonth = this.initialDate.getMonth();

    return (yearInt - initialYear) * 12 + (monthInt - 1) - initialMonth;
  }

  loadMarkers() {
    var self = this;

    var target = $('.google-map-auto-wrapper').data('target');

    var formData = [
      {
        name: 'action',
        value: 'getusermarkers',
      },
    ];

    // $.getJSON('/?rest_route=/user-map/markers', function(result){
    $.ajax({
      url: target,
      type: 'POST',
      data: formData,
      success: function (response) {
        var result = response.data;

        if (result.maker.length > 0) {
          self.createMarkers(result.maker, 'maker');
        }

        if (result.makerValide.length > 0) {
          self.createMarkers(result.makerValide, 'maker-valide');
        }

        if (result.appareilsAMatcher.length > 0) {
          self.createMarkers(result.appareilsAMatcher, 'appareils-a-matcher');
        }

        if (result.appareilsEnCours.length > 0) {
          self.createMarkers(result.appareilsEnCours, 'appareils-en-cours');
        }

        if (result.appareilsLivres.length > 0) {
          self.createMarkers(result.appareilsLivres, 'appareils-livres');
        }

        self.countVisibleMarkers();

        $('.google-map-auto .loading-markers').removeClass('showw');
      },
    });
  }

  createMarkers(markers, type) {
    var self = this;

    $.each(markers, function (key, marker) {
      var image = {
        url: image,
        size: new google.maps.Size(20, 20),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 20),
      };

      var zIndex = 0;

      if (type == 'maker') {
        image.url =
          'data:image/png;base64,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';
        image.size = new google.maps.Size(128, 128);
        (image.scaledSize = new google.maps.Size(33, 33)),
          (image.anchor = new google.maps.Point(16, 16));

        zIndex = 1;
      }

      if (type == 'maker-valide') {
        image.url =
          'https://mt.googleapis.com/vt/icon/name=icons/onion/1495-wht-star-blank-4x.png&filter=ff3F5BA9';
        image.size = new google.maps.Size(20, 20);
        image.anchor = new google.maps.Point(10, 10);

        zIndex = 2;
      }

      if (type == 'appareils-a-matcher') {
        image.url =
          'https://mt.googleapis.com/vt/icon/name=icons/onion/1493-wht-blank_maps-4x.png&filter=ffff0000';
        image.size = new google.maps.Size(32, 32);
        image.anchor = new google.maps.Point(0, 16);

        zIndex = 5;
      }

      if (type == 'appareils-en-cours') {
        image.url =
          'https://mt.googleapis.com/vt/icon/name=icons/onion/1493-wht-blank_maps-4x.png&filter=ffF8971B';
        image.size = new google.maps.Size(32, 32);
        image.anchor = new google.maps.Point(0, 16);

        zIndex = 4;
      }

      if (type == 'appareils-livres') {
        image.url =
          'https://mt.googleapis.com/vt/icon/name=icons/onion/1493-wht-blank_maps-4x.png&filter=ff009D57';
        image.size = new google.maps.Size(32, 32);
        image.anchor = new google.maps.Point(0, 16);

        zIndex = 3;
      }

      var item = new google.maps.Marker({
        type: type,
        map: self.map,
        position: marker.coordinates,
        title: marker.firstname,
        icon: image,
        markerData: marker,
        zIndex: zIndex,
      });

      item.addListener('click', function () {
        self.currentMarker = item;

        var timeout = 0;
        if ($('.sidebar-map.sidebar-map.marker-info').hasClass('open')) {
          $('.sidebar-map.sidebar-map.marker-info').removeClass('open');
          timeout = 500;
        }

        $('.sidebar-map .action-buttons').hide();
        $('.sidebar-map .action-buttons button').hide();

        if (item.type == 'appareils-a-matcher') {
          $('.sidebar-map .action-buttons').show();
          $('.sidebar-map .action-buttons [data-action=matching]').show();
        }

        if (item.type == 'appareils-en-cours') {
          $('.sidebar-map .action-buttons').show();
          $('.sidebar-map .action-buttons [data-action=switch_maker]').show();
          $(
            '.sidebar-map .action-buttons [data-action=project_delivered]'
          ).show();
        }

        $('.marker-info .marker-info-item').each(function (infoKey, element) {
          var type = $(element).data('key');

          $(element).show();

          if (item.markerData[type] == undefined) {
            $(element).hide();
          } else {
            if (typeof item.markerData[type] == 'string') {
              if (item.markerData[type].trim() == '') {
                $(element).hide();
              } else {
                $(element).find('.value').html(item.markerData[type]);
              }
            }

            if (type == 'firstname') {
              $('.marker-info .sidebar-map-header h1 span').html(
                item.markerData[type]
              );
            }

            if (type == 'photos') {
              var photoIndex = parseInt($(element).data('index'));
              $(element)
                .find('.value')
                .html(
                  '<a href="' +
                    item.markerData[type][photoIndex].url +
                    '" target="_blank">' +
                    item.markerData[type][photoIndex].name +
                    '</a>'
                );
            }

            if (type == 'makers') {
              var a = '';
              $.each(item.markerData[type], function (makerID, maker) {
                a += '<li>' + maker.name + '</li>';
              });
              $(element).find('.value').html(a);

              if (a == '') {
                $(element).hide();
              }
            }

            if (type == 'referents') {
              var r = '';
              var refs = item.markerData[type] || [];
              $.each(refs, function (idx, ref) {
                var label =
                  ref.name ||
                  (ref.first_name && ref.last_name
                    ? ref.first_name + ' ' + ref.last_name
                    : '');
                if (label === '') {
                  label = ref.email || 'Référent';
                }
                r +=
                  '<li>' +
                  label +
                  (ref.email ? ' (' + ref.email + ')' : '') +
                  '</li>';
              });
              $(element).find('.value').html(r);

              if (r == '') {
                $(element).hide();
              }
            }
          }
        });

        setTimeout(function () {
          $('.sidebar-map.sidebar-map.marker-info').addClass('open');
        }, timeout);
      });

      self.allmarkers.push(item);
    });
  }

  searchMarkers(countVisible = true) {
    var self = this;

    var searchKeys = ['firstname', 'lastname', 'parent', 'zip', 'city', 'mail'];
    var mySearch = '';

    var types = [];
    $('.google-map-auto input[type=checkbox]:checked').each(function () {
      types.push($(this).val());
    });

    if ($('.google-map-auto-wrapper input[name=search]').length > 0) {
      mySearch = $('.google-map-auto-wrapper input[name=search]')
        .val()
        .toLowerCase();
    }

    var from = 0;
    var to = 999999999999999999;

    if ($('#date_from').val() != '') {
      from = parseInt($('#date_from').val());
    }

    if ($('#date_to').val() != '') {
      to = parseInt($('#date_to').val());
    }

    $(this.allmarkers).each(function (key, marker) {
      // var found = true;
      var found = false;

      $(types).each(function (key, type) {
        if (marker.type == type) {
          found = true;
        }
      });

      if (
        marker.markerData.map_date >= from &&
        marker.markerData.map_date <= to &&
        found == true
      ) {
        found = true;
      } else {
        found = false;
      }

      if (mySearch != '' && found == true) {
        found = false;

        $(searchKeys).each(function (sKey, attr) {
          if (marker.markerData[attr] != null) {
            if (marker.markerData[attr].toLowerCase().indexOf(mySearch) != -1) {
              found = true;
            }
          }
        });
      }

      marker.setVisible(found);
    });

    if (countVisible === true) {
      self.countVisibleMarkers();
    }
  }

  countVisibleMarkers() {
    var self = this;

    self.markerTypes.forEach(function (type) {
      $(
        '.google-map-auto .sidebar-map .marker-group[data-type=' +
          type +
          '] span.counter'
      ).data('count', 0);
    });

    self.allmarkers.forEach(function (marker) {
      if (marker.visible == false) {
        return;
      }

      var count = $(
        '.google-map-auto .sidebar-map .marker-group[data-type=' +
          marker.type +
          '] span.counter'
      ).data('count');
      count++;

      $(
        '.google-map-auto .sidebar-map .marker-group[data-type=' +
          marker.type +
          '] span.counter'
      ).data('count', count);
    });

    self.markerTypes.forEach(function (type) {
      var count = $(
        '.google-map-auto .sidebar-map .marker-group[data-type=' +
          type +
          '] span.counter'
      ).data('count');
      $(
        '.google-map-auto .sidebar-map .marker-group[data-type=' +
          type +
          '] span.counter'
      ).html(count);
    });
  }

  removeMarker(marker) {
    if (!marker) {
      return;
    }

    marker.setVisible(false);
    marker.setMap(null);

    this.allmarkers = this.allmarkers.filter(function (item) {
      return item !== marker;
    });

    if (this.currentMarker === marker) {
      this.currentMarker = null;
    }

    this.countVisibleMarkers();
  }

  handleModal() {
    var self = this;

    $('#makersModal').on('show.bs.modal', function (event) {
      var button = $(event.relatedTarget);
      var action = button.data('action');

      $('#MakersForm input#maker_action_matching').val(action);

      if (action == 'matching') {
        $('#MakersForm .date-matching-section').show();
        $('#MakersForm .notif-section .notif-dest-section').show();
      } else {
        $('#MakersForm .date-matching-section').hide();
        $('#MakersForm .notif-section .notif-dest-section').hide();
      }

      $('.maker-select').html('').hide();
      $('.referent-select').html('').hide();
      $('#referent_suggestion_container').empty().hide();

      // Debug: contexte d'ouverture du modal + marker courant
      console.groupCollapsed(
        '[getmakersnearby] Ouverture du modal & préparation des données'
      );
      console.log('Action:', action);
      if (!self.currentMarker) {
        console.warn('[getmakersnearby] self.currentMarker est null/undefined');
      } else if (
        !self.currentMarker.markerData ||
        !self.currentMarker.markerData.coordinates
      ) {
        console.warn(
          '[getmakersnearby] Coordonnées manquantes sur le marker',
          self.currentMarker && self.currentMarker.markerData
        );
      } else {
        console.log('Marker ID:', self.currentMarker.markerData.ID);
        console.log('Coords:', self.currentMarker.markerData.coordinates);
      }

      var formData = [
        {
          name: 'action',
          value: 'getmakersnearby',
        },
        {
          name: 'lat',
          value: self.currentMarker.markerData.coordinates.lat,
        },
        {
          name: 'lng',
          value: self.currentMarker.markerData.coordinates.lng,
        },
      ];

      var target = $('.google-map-auto-wrapper').data('target');

      // Debug: URL et payload avant l'appel
      const debugPayload = formData.reduce(function (acc, cur) {
        acc[cur.name] = cur.value;
        return acc;
      }, {});
      console.log('URL cible:', target);
      console.log('Payload:', debugPayload);
      console.time('[getmakersnearby] requête');

      $.ajax({
        url: target,
        type: 'POST',
        data: formData,
        success: function (response) {
          console.timeEnd('[getmakersnearby] requête');
          console.groupCollapsed('[getmakersnearby] Réponse succès');
          console.log('Response brute:', response);
          var result = response.data;
          self.nearbyMakers = (result && result.users) ? result.users : [];
          self.makersById = {};
          $.each(self.nearbyMakers, function (idx, u) {
            self.makersById[u.ID] = u;
          });
          if (!result || !result.users) {
            console.warn(
              '[getmakersnearby] Réponse inattendue: .data ou .data.users absent',
              response
            );
          }

          var html = '<option>Sélectionner un maker</option>';

          $.each(result.users, function (userKey, user) {
            var fullName = user.first_name + ' ' + user.last_name;

            if (user.name === fullName) {
              html +=
                '<option value="' +
                user.ID +
                '">' +
                user.name +
                ' (' +
                Math.round(user.distance) +
                ' km)</option>';
            } else {
              html +=
                '<option value="' +
                user.ID +
                '">' +
                user.name +
                ' ' +
                user.first_name +
                ' ' +
                user.last_name +
                ' (' +
                Math.round(user.distance) +
                ' km)</option>';
            }
          });

          $('.maker-select').show().html(html).selectpicker();
          console.groupEnd();

          $.each(self.currentMarker.markerData.makers, function (key, maker) {
            $('select.maker-select:nth(' + key + ')').selectpicker(
              'val',
              maker.makerID
            );
          });

          // Si les référents sont déjà chargés, évaluer les suggestions
          if (self.allReferents && self.allReferents.length > 0) {
            var hasExistingRef =
              self.currentMarker &&
              self.currentMarker.markerData &&
              self.currentMarker.markerData.referent &&
              self.currentMarker.markerData.referent.ID;
            self.updateReferentSuggestions(!hasExistingRef);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.timeEnd('[getmakersnearby] requête');
          console.group('[getmakersnearby] Erreur AJAX');
          console.error('Status:', jqXHR.status, textStatus, errorThrown);
          // Essayer de décoder une éventuelle réponse JSON côté serveur
          var body = jqXHR && jqXHR.responseText;
          console.log('ResponseText (brut):', body);
          try {
            var asJson = JSON.parse(body);
            console.log('Response JSON parsé:', asJson);
          } catch (e) {
            console.debug(
              '[getmakersnearby] Réponse non-JSON (parse échoué)',
              e
            );
          }
          console.log('URL:', target);
          console.log('Payload:', debugPayload);
          // Entêtes utiles pour debug (si disponibles)
          try {
            console.log(
              'X-Powered-By:',
              jqXHR.getResponseHeader && jqXHR.getResponseHeader('X-Powered-By')
            );
            console.log(
              'Content-Type:',
              jqXHR.getResponseHeader && jqXHR.getResponseHeader('Content-Type')
            );
          } catch (e) {
            console.debug(
              '[getmakersnearby] Impossible de lire les entêtes de réponse',
              e
            );
          }
          console.groupEnd();
        },
        complete: function () {
          console.groupEnd();
        },
      });

      // Charger la liste des référents (tous approuvés)
      var refData = [{ name: 'action', value: 'getreferents' }];

      $.ajax({
        url: target,
        type: 'POST',
        data: refData,
        success: function (response) {
          var result = response.data;
          self.allReferents = (result && result.users) ? result.users : [];

          // Pré-sélection si déjà un référent sur le marker
          var initialRefVal = (self.currentMarker.markerData.referent && self.currentMarker.markerData.referent.ID)
            ? self.currentMarker.markerData.referent.ID
            : '';

          self.renderReferentSelect([], initialRefVal);

          // Si les makers sont déjà disponibles, calculer immédiatement les suggestions
          if (self.nearbyMakers && self.nearbyMakers.length > 0) {
            var hasExistingRef = !!initialRefVal;
            self.updateReferentSuggestions(!hasExistingRef);
          }
        },
      });
    });

    $(document).off('change.makerSuggest', 'select.maker-select');
    $(document).on('change.makerSuggest', 'select.maker-select', function () {
      self.updateReferentSuggestions(true);
    });

    $(document).off('change.referentCheck', 'select.referent-select');
    $(document).on('change.referentCheck', 'select.referent-select', function () {
      self.updateReferentSuggestions(false);
    });

    $(document).off('click.applyRef', '.btn-apply-suggested-referent');
    $(document).on('click.applyRef', '.btn-apply-suggested-referent', function (e) {
      e.preventDefault();
      var refId = $(this).data('referent-id');
      if (refId) {
        $('.referent-select').selectpicker('val', refId).trigger('change');
      }
    });

    $('#makersModal').on('hide.bs.modal', function () {
      $('.maker-select').selectpicker('destroy');
      $('.referent-select').selectpicker('destroy');
      $('#referent_suggestion_container').empty().hide();
      $('#maker_comment').val('');
    });

    $('#MakersForm').on('submit', function (event) {
      event.preventDefault();

      var _this = $(this);

      var target = $('.google-map-auto-wrapper').data('target');
      var formData = _this.serializeArray();

      formData.push({
        name: 'ID',
        value: self.currentMarker.markerData.ID,
      });

      formData.push({
        name: 'action',
        value: 'updatedevice',
      });

      $.ajax({
        url: target,
        type: 'POST',
        data: formData,
        success: function (response) {
          var result = response.data;

          self.currentMarker.markerData = result;

          if (self.currentMarker.markerData.device_statut == 3) {
            self.removeMarker(self.currentMarker);
            $('.sidebar-map.sidebar-map.marker-info').removeClass('open');
            $('#makersModal').modal('hide');
            return;
          }

          var image = {};
          image.size = new google.maps.Size(32, 32);
          image.anchor = new google.maps.Point(0, 16);

          if (self.currentMarker.markerData.device_statut == 0) {
            self.currentMarker.type = 'appareils-a-matcher';
            image.url =
              'https://mt.googleapis.com/vt/icon/name=icons/onion/1493-wht-blank_maps-4x.png&filter=ffff0000';
            self.currentMarker.setIcon(image);
          }

          if (self.currentMarker.markerData.device_statut == 1) {
            self.currentMarker.type = 'appareils-en-cours';
            image.url =
              'https://mt.googleapis.com/vt/icon/name=icons/onion/1493-wht-blank_maps-4x.png&filter=ffF8971B';
            self.currentMarker.setIcon(image);
          }

          if (self.currentMarker.markerData.device_statut == 2) {
            self.currentMarker.type = 'appareils-livres';
            image.url =
              'https://mt.googleapis.com/vt/icon/name=icons/onion/1493-wht-blank_maps-4x.png&filter=ff009D57';
            self.currentMarker.setIcon(image);
          }

          google.maps.event.trigger(self.currentMarker, 'click');

          $('#makersModal').modal('hide');
        },
      });
    });

    $('#deliveredDeviceForm').on('submit', function (event) {
      // var self = this;

      event.preventDefault();

      var _this = $(this);
      var formData = _this.serializeArray();

      var target = $('.google-map-auto-wrapper').data('target');

      formData.push({
        name: 'ID',
        value: self.currentMarker.markerData.ID,
      });

      formData.push({
        name: 'action',
        value: 'delivereddevice',
      });

      $.ajax({
        url: target,
        type: 'POST',
        data: formData,
        success: function (response) {
          // $.post('/?rest_route=/devices-manager/delivered-device', data, function(result){

          var result = response.data;

          var image = {};
          image.url =
            'https://mt.googleapis.com/vt/icon/name=icons/onion/1493-wht-blank_maps-4x.png&filter=ff009D57';
          image.size = new google.maps.Size(32, 32);
          image.anchor = new google.maps.Point(0, 16);

          self.currentMarker.setIcon(image);
          self.currentMarker.markerData = result;
          self.currentMarker.type = 'appareils-livres';

          google.maps.event.trigger(self.currentMarker, 'click');

          $('#deliveredProjectModal').modal('hide');
        },
      });
    });
  }

  renderReferentSelect(suggestedReferents, currentVal) {
    const self = this;
    if (!self.allReferents || self.allReferents.length === 0) {
      return;
    }

    let selectedVal = currentVal;
    if (typeof selectedVal === 'undefined' || selectedVal === null) {
      selectedVal = $('.referent-select').val() || '';
    }

    let html = '<option value="">Sélectionner un référent</option>';
    const hasSuggestions = suggestedReferents && suggestedReferents.length > 0;

    if (hasSuggestions) {
      html += '<optgroup label="⭐ Référent(s) recommandé(s) (projets en commun)">';
      const suggestedIds = {};
      $.each(suggestedReferents, function (idx, sRef) {
        suggestedIds[sRef.id] = true;
        const matched = self.allReferents.find(function (r) {
          return String(r.ID) === String(sRef.id);
        });
        const counts =
          matched && typeof matched.ongoing_count !== 'undefined'
            ? ' [' + matched.ongoing_count + '/' + (matched.total_count || 0) + ']'
            : '';
        const subtext =
          sRef.count + ' projet' + (sRef.count > 1 ? 's' : '') + ' avec ce maker';
        html +=
          '<option value="' +
          sRef.id +
          '" data-subtext="' +
          subtext +
          '">★ ' +
          sRef.name +
          counts +
          '</option>';
      });
      html += '</optgroup>';

      html += '<optgroup label="Tous les référents">';
      $.each(self.allReferents, function (i, user) {
        const baseLabel =
          user.first_name && user.last_name
            ? user.first_name + ' ' + user.last_name
            : user.name;
        const counts =
          typeof user.ongoing_count !== 'undefined'
            ? ' [' +
              user.ongoing_count +
              '/' +
              (user.total_count || 0) +
              ']'
            : '';
        html +=
          '<option value="' +
          user.ID +
          '">' +
          baseLabel +
          counts +
          '</option>';
      });
      html += '</optgroup>';
    } else {
      $.each(self.allReferents, function (i, user) {
        const baseLabel =
          user.first_name && user.last_name
            ? user.first_name + ' ' + user.last_name
            : user.name;
        const counts =
          typeof user.ongoing_count !== 'undefined'
            ? ' [' +
              user.ongoing_count +
              '/' +
              (user.total_count || 0) +
              ']'
            : '';
        html +=
          '<option value="' +
          user.ID +
          '">' +
          baseLabel +
          counts +
          '</option>';
      });
    }

    const $refSelect = $('.referent-select');
    $refSelect.html(html);

    if ($refSelect.data('selectpicker')) {
      $refSelect.selectpicker('refresh');
    } else {
      $refSelect.selectpicker();
    }

    if (selectedVal) {
      $refSelect.selectpicker('val', selectedVal);
    }
  }

  updateReferentSuggestions(autoSelectIfEmpty) {
    const self = this;
    if (!self.allReferents || self.allReferents.length === 0) {
      return;
    }

    const selectedMakerIds = [];
    $('select.maker-select').each(function () {
      const val = $(this).val();
      if (val && !isNaN(val) && parseInt(val, 10) > 0) {
        selectedMakerIds.push(parseInt(val, 10));
      }
    });

    const $container = $('#referent_suggestion_container');

    if (selectedMakerIds.length === 0) {
      self.renderReferentSelect([]);
      if ($container.length) {
        $container.empty().hide();
      }
      return;
    }

    // Agréger les référents passés pour l'ensemble des makers sélectionnés
    const referentStats = {};
    $.each(selectedMakerIds, function (i, makerId) {
      const maker = self.makersById ? self.makersById[makerId] : null;
      if (maker && maker.past_referents && maker.past_referents.length > 0) {
        const makerName =
          maker.first_name && maker.last_name
            ? maker.first_name + ' ' + maker.last_name
            : maker.name;
        $.each(maker.past_referents, function (j, ref) {
          if (!referentStats[ref.id]) {
            referentStats[ref.id] = {
              id: ref.id,
              name: ref.name,
              count: 0,
              makers: [],
            };
          }
          referentStats[ref.id].count += parseInt(ref.count, 10) || 1;
          referentStats[ref.id].makers.push(makerName);
        });
      }
    });

    const suggestedList = Object.keys(referentStats).map(function (k) {
      return referentStats[k];
    });

    suggestedList.sort(function (a, b) {
      return b.count - a.count;
    });

    if (suggestedList.length === 0) {
      self.renderReferentSelect([]);
      if ($container.length) {
        $container.empty().hide();
      }
      return;
    }

    let currentVal = $('.referent-select').val();
    const topRef = suggestedList[0];

    // Si aucun référent n'est sélectionné et autoSelectIfEmpty est demandé
    if (
      autoSelectIfEmpty &&
      (!currentVal || currentVal === '' || currentVal == '0')
    ) {
      currentVal = topRef.id;
    }

    self.renderReferentSelect(suggestedList, currentVal);

    if ($container.length) {
      if (currentVal && String(currentVal) === String(topRef.id)) {
        const msg =
          '<div class="alert alert-info" style="margin-top: 10px; margin-bottom: 12px; padding: 10px 14px; font-size: 13px; line-height: 1.45; border-radius: 4px; background-color: #e8f4fd; border: 1px solid #bee5eb; color: #0c5460;">' +
          '<i class="fa fa-lightbulb-o" style="font-size: 16px; margin-right: 6px; color: #17a2b8; vertical-align: middle;"></i> ' +
          '<strong>' +
          topRef.name +
          '</strong> a été pré-sélectionné(e) car ce maker a déjà collaboré avec sur <strong>' +
          topRef.count +
          ' projet' +
          (topRef.count > 1 ? 's' : '') +
          '</strong>.' +
          '<div style="font-size: 12px; color: #555; margin-top: 4px;">Vous pouvez conserver ce référent ou en choisir un autre dans la liste ci-dessus.</div>' +
          '</div>';
        $container.html(msg).show();
      } else if (currentVal && String(currentVal) !== String(topRef.id)) {
        const msg =
          '<div class="alert alert-warning" style="margin-top: 10px; margin-bottom: 12px; padding: 10px 14px; font-size: 13px; line-height: 1.45; border-radius: 4px; background-color: #fff3cd; border: 1px solid #ffeeba; color: #856404;">' +
          '<div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;">' +
          '<div><i class="fa fa-info-circle" style="font-size: 16px; margin-right: 6px; color: #ffc107; vertical-align: middle;"></i> ' +
          'Ce maker a déjà travaillé avec <strong>' +
          topRef.name +
          '</strong> (' +
          topRef.count +
          ' projet' +
          (topRef.count > 1 ? 's' : '') +
          ').</div>' +
          '<button type="button" class="btn btn-sm btn-outline-dark btn-apply-suggested-referent" data-referent-id="' +
          topRef.id +
          '" style="font-weight: 600; font-size: 12px; padding: 3px 10px; cursor: pointer;">' +
          '<i class="fa fa-check"></i> Choisir ' +
          topRef.name +
          '</button>' +
          '</div>' +
          '</div>';
        $container.html(msg).show();
      } else {
        const msg =
          '<div class="alert alert-info" style="margin-top: 10px; margin-bottom: 12px; padding: 10px 14px; font-size: 13px; line-height: 1.45; border-radius: 4px; background-color: #e8f4fd; border: 1px solid #bee5eb; color: #0c5460;">' +
          '<i class="fa fa-lightbulb-o" style="font-size: 16px; margin-right: 6px; color: #17a2b8; vertical-align: middle;"></i> ' +
          'Suggestion : <strong>' +
          topRef.name +
          '</strong> a déjà collaboré avec ce maker sur <strong>' +
          topRef.count +
          ' projet' +
          (topRef.count > 1 ? 's' : '') +
          '</strong>. ' +
          '<button type="button" class="btn btn-sm btn-primary btn-apply-suggested-referent ml-2" data-referent-id="' +
          topRef.id +
          '" style="font-weight: 600; font-size: 12px; padding: 3px 10px; margin-left: 8px; cursor: pointer;">' +
          'Sélectionner ' +
          topRef.name +
          '</button>' +
          '</div>';
        $container.html(msg).show();
      }
    }
  }
}

export default EnableGoogleMaps;



// WEBPACK FOOTER //
// ./scripts/class/EnableGoogleMaps.js